import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useDiscountStore, usePrivateLinkStore } from '../stores';

/**
 *
 *
 * O hook é responsável por redirecionar as pessoas dentro da página de checkout preservando o cupom, caso esteja aplicado.
 * Se não houver ingresso no carrinho o hook fará um redirect para página de seleção de ingressos
 *
 * Não funciona com o redirect quando o cupom vem de outros locais, ex: depois de logar com o google.
 * 
 * @hook
 * @legacy
 */
const useEventHistory = () => {
  const navigate = useNavigate();
  const discountStore = useDiscountStore();
  const privateLinkStore = usePrivateLinkStore();

  const { discount } = discountStore;
  const { linkName } = privateLinkStore;


  const queryParams = React.useMemo(() => {
    const params = new URLSearchParams();
    
    if (discount) {
      params.set('coupon', discount.name);
    }

    if (linkName) {
      params.set('linkname', linkName);
    }

    return params.toString() ? `?${params.toString()}` : '';
  }, [discount, linkName]);

  const push = React.useCallback(
    (url) => {
      navigate(`${url}${queryParams}`, { replace: false });
    },
    [queryParams, navigate],
  );

  const replace = React.useCallback(
    url => {
      navigate(`${url}${queryParams}`, { replace: true });
    },
    [navigate, queryParams],
  );

  return React.useMemo(() => ({ push, replace }), [push, replace]);
};

export default useEventHistory;
